var initSquare;

initSquare = function(module) {
  var $, winHeight, winWidth;
  $ = require('jquery');
  winWidth = $(window).width();
  winHeight = $(window).height();
  if (winWidth < 1024 && module.parents('.features--unswipe').length === 0) {
    return module.height(winHeight);
  }
};

module.exports = initSquare;
